import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  page: {
    maxWidth: '1280px',
    margin: 'auto',
    padding: { xs: '28px 18px 48px', md: '48px 32px 72px' },
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: '36px', md: '48px' },
  },
  topBar: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'stretch', md: 'flex-end' },
    justifyContent: 'space-between',
    gap: '20px',
    paddingBottom: '18px',
    borderBottom: '1px solid #E6E8F2',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    gap: '18px',
    paddingBottom: '13px',
    marginBottom: '22px',
    borderBottom: '1px solid #E6E8F2',
  },
  sectionBadge: {
    display: 'inline-block',
    color: 'primary.main',
    backgroundColor: '#FAEAF1',
    borderRadius: '5px',
    padding: '3px 7px',
    fontSize: '9px',
    fontWeight: '800',
    letterSpacing: '.8px',
    marginBottom: '5px',
  },
  seeAll: {
    color: 'primary.main',
    fontSize: '12px',
    fontWeight: '700',
    whiteSpace: 'nowrap',
  },
  eyebrow: {
    color: 'primary.main',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '1.3px',
  },
  pageTitle: {
    color: '#1F2233',
    fontSize: { xs: '28px', md: '36px' },
    fontWeight: '700',
    lineHeight: 1.2,
  },
  subtitle: { color: '#6B7085', fontSize: '13px', marginTop: '6px' },
  search: {
    width: { xs: '100%', md: '360px' },
    backgroundColor: 'common.white',
    '& .MuiOutlinedInput-root': { borderRadius: '12px' },
  },
  contentGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', lg: 'minmax(0, 2fr) minmax(260px, 1fr)' },
    gap: { xs: '28px', lg: '32px' },
    alignItems: 'start',
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
    gap: '22px',
  },
  seasonalSection: { marginTop: { xs: '36px', md: '44px' } },
  seasonalTitle: {
    color: '#1F2233',
    fontSize: { xs: '24px', md: '30px' },
    fontWeight: '700',
  },
  sliderWrap: { position: 'relative' },
  seasonalSlider: {
    display: 'flex',
    gap: '18px',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    scrollbarWidth: 'none',
    padding: '2px 2px 14px',
    '&::-webkit-scrollbar': { display: 'none' },
  },
  seasonalSlide: {
    flex: { xs: '0 0 84%', sm: '0 0 47%', md: '0 0 31%' },
    minWidth: 0,
    scrollSnapAlign: 'start',
  },
  seasonalCard: {
    width: '100%',
    height: '100%',
    minWidth: 0,
    padding: '10px',
    borderColor: '#E6E8F2',
    boxShadow: '0 8px 24px rgba(31,34,51,.06)',
  },
  seasonalImage: { width: '100%', height: '170px' },
  seasonalHeading: { width: '100%', color: '#1F2233', fontSize: '15px' },
  seasonalDescription: { width: '100%', color: '#6B7085' },
  sliderButton: {
    position: 'absolute',
    zIndex: 2,
    top: '42%',
    transform: 'translateY(-50%)',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    border: '1px solid #E4D5DC',
    backgroundColor: 'common.white',
    color: 'primary.main',
    boxShadow: '0 5px 16px rgba(31,34,51,.14)',
    cursor: 'pointer',
    fontSize: '25px',
    lineHeight: 1,
  },
  sliderButtonPrevious: { left: { xs: '-9px', md: '-16px' } },
  sliderButtonNext: { right: { xs: '-9px', md: '-16px' } },
  trendingGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: '7fr 5fr' },
    gap: '20px',
  },
  featuredCard: {
    minHeight: { xs: '320px', md: '390px' },
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '14px',
    backgroundColor: '#333',
  },
  featuredImage: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  featuredOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to top, rgba(0,0,0,.9), rgba(0,0,0,.15))',
  },
  featuredContent: {
    position: 'absolute',
    zIndex: 1,
    left: 0,
    right: 0,
    bottom: 0,
    padding: { xs: '20px', md: '25px' },
    color: 'common.white',
  },
  featuredBadge: {
    display: 'inline-block',
    backgroundColor: 'primary.main',
    borderRadius: '999px',
    padding: '5px 10px',
    fontSize: '10px',
    fontWeight: '700',
  },
  featuredTitle: {
    color: 'common.white',
    fontSize: { xs: '18px', md: '21px' },
    fontWeight: '700',
    lineHeight: 1.3,
    marginTop: '10px',
  },
  featuredDescription: {
    color: '#E8E8E8',
    fontSize: '12px',
    marginTop: '8px',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  featuredMeta: {
    color: '#E0E0E0',
    fontSize: '11px',
    marginTop: '14px',
    paddingTop: '10px',
    borderTop: '1px solid rgba(255,255,255,.25)',
  },
  trendingList: { display: 'flex', flexDirection: 'column', gap: '12px' },
  trendingCard: {
    display: 'flex',
    gap: '12px',
    padding: '11px',
    minHeight: '112px',
    backgroundColor: 'common.white',
    border: '1px solid #E6E8F2',
    borderRadius: '12px',
    boxShadow: '0 5px 16px rgba(31,34,51,.05)',
  },
  trendingImage: {
    width: '88px',
    minWidth: '88px',
    height: '88px',
    borderRadius: '9px',
    objectFit: 'cover',
  },
  trendingBody: { display: 'flex', flexDirection: 'column', minWidth: 0 },
  trendingBadge: {
    alignSelf: 'flex-start',
    color: 'primary.main',
    backgroundColor: '#FAEAF1',
    borderRadius: '4px',
    padding: '2px 5px',
    fontSize: '9px',
    fontWeight: '700',
  },
  trendingTitle: {
    color: '#1F2233',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: 1.35,
    marginTop: '5px',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  },
  trendingMeta: { color: '#777B8E', fontSize: '9px', marginTop: 'auto' },
  blogCard: {
    width: '100%',
    minWidth: 0,
    padding: '10px',
    borderColor: '#E6E8F2',
    boxShadow: '0 8px 24px rgba(31, 34, 51, 0.06)',
  },
  blogImage: { width: '100%', height: { xs: '190px', md: '210px' } },
  blogHeading: { width: '100%', color: '#1F2233', fontSize: '17px' },
  blogDescription: { width: '100%', color: '#6B7085' },
  empty: { padding: '48px 12px', textAlign: 'center', color: '#6B7085' },
  sidebar: {
    position: { xs: 'static', lg: 'sticky' },
    top: '120px',
  },
  categoryPanel: {
    backgroundColor: 'common.white',
    border: '1px solid #E6E8F2',
    borderRadius: '14px',
    overflow: 'hidden',
  },
  categoryHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '10px',
    padding: '14px 16px',
    background: 'linear-gradient(110deg, #8D174C, #48132A)',
    border: 0,
    width: '100%',
    cursor: 'pointer',
    textAlign: 'left',
  },
  categoryHeaderTitle: {
    color: 'common.white',
    fontSize: '14px',
    fontWeight: '800',
  },
  categoryCount: {
    color: 'common.white',
    backgroundColor: 'rgba(255,255,255,.18)',
    padding: '3px 8px',
    borderRadius: '999px',
    fontSize: '9px',
    fontWeight: '700',
  },
  categoryHeaderMeta: { display: 'flex', alignItems: 'center', gap: '10px' },
  categoryChevron: {
    color: 'common.white',
    fontSize: '20px',
    lineHeight: 1,
    transform: 'rotate(0deg)',
    transition: 'transform .2s ease',
  },
  categoryChevronOpen: { transform: 'rotate(180deg)' },
  categoryLinks: { padding: '8px 12px 12px' },
  categoryItem: { borderBottom: '1px solid #F0F1F6' },
  categoryLink: {
    display: 'flex',
    justifyContent: 'space-between',
    color: '#45495B',
    fontSize: '12px',
    fontWeight: '600',
    padding: '9px 8px',
    width: '100%',
    border: 0,
    background: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': { color: 'primary.main', backgroundColor: '#FAF2F5' },
  },
  itemChevron: {
    fontSize: '18px',
    lineHeight: 1,
    transition: 'transform .2s ease',
  },
  itemChevronOpen: { transform: 'rotate(90deg)' },
  categorySubLinks: {
    padding: '2px 8px 9px 18px',
    borderLeft: '2px solid #E8CBD8',
    margin: '0 8px 8px',
  },
  categorySubLink: {
    color: '#64687A',
    fontSize: '11px',
    padding: '6px 8px',
    borderRadius: '6px',
    '&:hover': { color: 'primary.main', backgroundColor: '#FAF2F5' },
  },
  cta: {
    borderRadius: '18px',
    padding: { xs: '24px', md: '32px' },
    background:
      'linear-gradient(110deg, #48132A 0%, #8D174C 55%, #5C1A37 100%)',
    color: 'common.white',
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    justifyContent: 'space-between',
    alignItems: { xs: 'stretch', md: 'center' },
    gap: '24px',
  },
  ctaLabel: {
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '1px',
    color: '#F6CBDD',
  },
  ctaTitle: {
    fontSize: { xs: '22px', md: '28px' },
    fontWeight: '700',
    marginTop: '5px',
  },
  ctaText: { fontSize: '13px', color: '#F7DCE8', marginTop: '7px' },
  ctaActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    minWidth: { md: '230px' },
  },
  primaryAction: {
    display: 'block',
    textAlign: 'center',
    color: 'primary.main',
    backgroundColor: 'common.white',
    padding: '12px 18px',
    borderRadius: '10px',
    fontSize: '13px',
    fontWeight: '700',
  },
  secondaryAction: {
    color: 'common.white',
    border: '1px solid rgba(255,255,255,.75)',
    padding: '11px 18px',
    borderRadius: '10px',
    textAlign: 'center',
    textDecoration: 'none',
    fontSize: '13px',
    fontWeight: '600',
    background: 'transparent',
    cursor: 'pointer',
  },
  quickTitle: {
    color: '#1F2233',
    fontSize: { xs: '21px', md: '25px' },
    fontWeight: '700',
    marginBottom: '18px',
  },
  quickGrid: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
    gap: '16px',
  },
  quickPanel: {
    backgroundColor: 'common.white',
    border: '1px solid #E6E8F2',
    borderRadius: '14px',
    padding: '18px',
  },
  quickHeading: {
    color: '#1F2233',
    fontWeight: '700',
    fontSize: '16px',
    marginBottom: '12px',
  },
  linkList: { display: 'flex', flexDirection: 'column', gap: '8px' },
  quickLink: {
    color: 'primary.main',
    fontSize: '13px',
    '&:hover': { textDecoration: 'underline' },
  },
})

export type StylesClassNames = StylesClasses<typeof styles>
export default styles
